import React from "react";

import PlanTableHeader from "./PlanTableHeader";
import PlanTableRow from "./PlanTableRow";
import PageNoData from "../../../CommonPage/PageNoData";

function PlanTableInfo(props) {
  const { tableConfig, tableData, handleChange, onClickEdit } = props;

  return (
    <div className="w-full relative">
      <PlanTableHeader tableConfig={tableConfig} />

      {Array.isArray(tableData) && tableData.length > 0 ? (
        tableData.map((rowData, index) => (
          <PlanTableRow
            key={index}
            tableConfig={tableConfig}
            rowData={rowData}
            indexNum={index}
            handleChange={handleChange}
            onClickEdit={onClickEdit}
          />
        ))
      ) : (
        <div>
          <PageNoData noDataMessage="データなし!" noDataAction />
        </div>
      )}
    </div>
  );
}

export default PlanTableInfo;
